import { IconName } from '../../../../../React/Common/Components/Icon'
import { MainMenuApp } from '../../../../../NonReact/constants/AppMenuConstants'
import { Page } from '../../../../../NonReact/constants/Components/Page'

export enum RouteID {
    PRESENCE = 'presence',
    INSIGHTS = 'insights',
    AUTH = 'auth',
    FORGOT_PASSWORD = 'forgotPassword',
    CHANGE_PASSWORD = 'changePassword',
    CHANGE_LANGUAGE = 'changeLanguage',
    RESET_PASSWORD = 'resetPassword',
    MFA = 'mfa',
    TERMS_AND_CONDITIONS = 'termsAndConditions',
    COOKIE_POLICY = 'cookiePolicy',
    PRIVACY_POLICY = 'privacyPolicy',
    REPORTING_PORTAL = 'reportingPortal',
    TEAMS_AUTH = 'teamsAuth',
    CRM_INTEGRATION = 'crmIntegration',
    CHANGE_USER_AGENT = 'changeUserAgent'
}

export type AppMenuEntry = {
    enabled: boolean
    title: string
    icon: IconName
    menu: MainMenuApp
    pages?: RouteID[]
    oldPages?: Page[]
}
